import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { Input } from '..';

function PhoneInput({ onChange, label, value, errorText, style }) {
    return (
        <InputMask
            mask="(999) 999 9999"
            maskChar=" "
            value={value}
            onChange={onChange}
        >
            {() => (
                <Input
                    className="form-field"
                    style={style}
                    label={label}
                    variant="outlined"
                    error={!!errorText}
                    helperText={errorText}
                />
            )}
        </InputMask>
    );
}

PhoneInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    errorText: PropTypes.string,
    style: PropTypes.shape({}),
};

PhoneInput.defaultProps = {
    value: '',
    errorText: '',
    style: {},
};

export default PhoneInput;
